import React, { createContext, useEffect, useContext, useReducer } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  fetchApplication, 
  startedApplication, 
  saveAnswers, 
  Answer, 
  recoveryAnswers 
} from '../api/applicationService';
import { QuoteContext } from './quoteContext';
import { useSearchParams } from 'react-router-dom';

const FORM_ID = '940c995c-b687-4601-b59f-d4cef0cdf5b9';

export type AnswerType = {
  questionId: string;
  groupId: string;
  section: number;
  order: number;
  value: string;
  extraID?: string;
};

export type GroupMemory = {
  group: string;
  memory: number;
}

export type QuestionType = {
  key: string;
  id: string;
  title: any;
  section: number;
  order: number;
  required: boolean;
  visible: boolean;
  ui: any;
  options: any[];
  placeholder: any;
  tag: string;
  classname: string;
  subgroupId?: string;
  format?: string;
  min?: number;
  max?: number;
  step?: number;
};

interface ApplicationState {
  id: number;
  questions: QuestionType[];
  page: number;
  lock: boolean;
  answers: AnswerType[];
  partialAnswers: Answer[];
  pagePreviewMemory: number;
  questionAdditionals: QuestionType[];
  hasError: boolean;
  groupsMemory: GroupMemory[];
  loading: boolean;

}

interface ApplicationContextType extends ApplicationState {
  setPage: (page: number) => void;
  nextPage: () => void;
  beforePage: () => void;
  setQuestions: (questions: any[]) => void;
  setAnswers: (answers: AnswerType[]) => void;
  setQuestionsAdditionals: (questionsAdditionals: QuestionType[]) => void;
  setHasError: (haveError: boolean) => void;
  setGroupsMemory: (questionsMemory: GroupMemory[]) => void;
  setLoader: (loading: boolean) => void;

}

const initialState: ApplicationState = {
  id: 0,
  questions: [],
  page: 1,
  lock: true,
  answers: [],
  partialAnswers: [],
  pagePreviewMemory: 0,
  questionAdditionals: [],
  hasError: false,
  groupsMemory: [],
  loading: false,

};

const reducer = (state: ApplicationState, action: { type: string; payload?: any }): ApplicationState => {
  switch (action.type) {
    case 'SET_ID':
      return { ...state, id: action.payload };
    case 'SET_QUESTIONS':
      return { ...state, questions: action.payload };
    case 'SET_PAGE':
      return { ...state, page: action.payload };
    case 'SET_LOCK':
      return { ...state, lock: action.payload };
    case 'SET_ANSWERS':
      return { ...state, answers: action.payload };
    case 'SET_PARTIAL_ANSWERS':
      return { ...state, partialAnswers: action.payload };
    case 'SET_QUESTION_ADDITIONALS':
      return { ...state, questionAdditionals: action.payload };
    case 'SET_HAS_ERROR':
      return { ...state, hasError: action.payload };
    case 'SET_LOADER':
      return { ...state, loading: action.payload };
    case 'SET_GROUPS_MEMORY':
      return { ...state, groupsMemory: action.payload };

    default:
      return state;
  }
};

export const ApplicationContext = createContext<ApplicationContextType>({
  ...initialState,
  setPage: () => {},
  nextPage: () => {},
  beforePage: () => {},
  setQuestions: () => {},
  setAnswers: () => {},
  setQuestionsAdditionals: () => {},
  setHasError: () => {},
  setGroupsMemory: () => {},
  setLoader: () => {},

});

export const ApplicationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();
  const [state, dispatch] = useReducer(reducer, initialState);
  const { quoteID } = useContext(QuoteContext);
  const [searchParams] = useSearchParams();
  const loadCurrentAnswers = async (page: number, formID = state.id) => {
    dispatch({ type: 'SET_LOADER', payload: true });
    const currentAnswers = await recoveryAnswers(formID, page);
    
    const mappedAnswers = currentAnswers?.map((answer) => ({
      formId: answer.form_id,
      questionId: answer.question_id,
      groupId: answer.group_id,
      value: answer.answer,
      section: answer.page,
      order: answer.order,
      extraID: answer.extra_id,
    }));

    dispatch({ type: 'SET_ANSWERS', payload: mappedAnswers });
    dispatch({ type: 'SET_PARTIAL_ANSWERS', payload: currentAnswers });
    dispatch({ type: 'SET_LOADER', payload: false });
  };

  const loadQuestionsAndApplication = async () => {
    const quoteIDURL = searchParams.get('quoteID') || '';
    if (!quoteID && !quoteIDURL) {
      alert('No se ha encontrado el ID de la cotización');
      navigate('/');
    }
    dispatch({ type: 'SET_LOADER', payload: true });
    const formApplication = await startedApplication(FORM_ID, quoteID || quoteIDURL);
    dispatch({ type: 'SET_ID', payload: formApplication.id });
    dispatch({ type: 'SET_PAGE', payload: formApplication.last_page || 1 });

    const questionsData = await fetchApplication(FORM_ID);
    dispatch({ type: 'SET_QUESTIONS', payload: questionsData.questions });

    loadCurrentAnswers(formApplication.last_page || 1, formApplication.id);

    dispatch({ type: 'SET_LOADER', payload: false });
  };

  useEffect(() => {
    loadQuestionsAndApplication();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quoteID, searchParams]);

  useEffect(() => {
    let lock = false;
    if (state.page === 10) {
      let pass1 = -1;
      let pass2 = -1;
      if (state?.answers?.some((answer) => answer.questionId === '29e42fe5-41b3-493b-bff4-97b1fd018aa6'
        && answer.value === '1')) {

          if (state.answers?.find((answer) => answer.questionId === '7d6b9cb8-9e29-47ae-b872-103dd73d4735')){
            if (state.answers?.some((answer) => answer.questionId === '7d6b9cb8-9e29-47ae-b872-103dd73d4735' 
              && answer.value === '1')) {
              pass1 = 0;
              
              if (state.answers?.some((answer) => answer.questionId === '2657dd0e-9eaf-4455-a8f3-31f9367d8bb6' 
                && answer.groupId === 'cb3a961a-9277-4bde-8668-a820b573b94c'
                && answer.value.length > 0)) {
                pass1 = 1;
              }
            }
          }

          if (state.answers?.find((answer) => answer.questionId === '468c9623-cd96-477e-a64d-67727d21ea3a')){
            if (state.answers?.some((answer) => answer.questionId === '468c9623-cd96-477e-a64d-67727d21ea3a' 
              && answer.value === '1')) {
              pass2 = 0;
              
              if (state.answers?.some((answer) => answer.questionId === '2657dd0e-9eaf-4455-a8f3-31f9367d8bb6' 
                && answer.groupId === 'b2524b28-a8e2-4913-a8c1-e789690a4c34'
                && answer.value.length > 0)) {
                pass2 = 1;
              }
            }
          }
          if ((pass1 === -1 && pass2 === 1) || (pass1 === 1 && pass2 === -1) || (pass1 === 1 && pass2 === 1)) {
            lock = false;
          } else {
            lock = true;
          }
        dispatch({ type: 'SET_LOCK', payload: lock });
      }
    }

    if (state.page === 14) {
      const getValuesPercentages = state.answers?.filter(
        (answer) => answer.groupId === '39e21745-9a16-4ae6-a170-d30535f79291' && answer.questionId === 'e00cd1a2-7eaf-4e36-ab0a-97dfe49ec7bc'
      ).map((answer) => parseInt(answer.value));
      const sumValuesPercentages = getValuesPercentages?.reduce((acc, value) => acc + value, 0);
      if (sumValuesPercentages !== 100) {
        lock = true;
        dispatch({ type: 'SET_LOCK', payload: lock });
        return;
      }
    }

    for (const question of state.questions) {
      if (
        question.section === state.page &&
        question.required && 
        question.visible && 
        question.ui !== 'buttonGroup' && question.ui !== 'switch' && 
        ((question.ui === 'checkbox' && !state.answers?.some((answer) => answer.questionId === question.id && answer.value === '1')) ||
        !state.answers?.some((answer) => answer.questionId === question.id && answer.value))
      ) {
        lock = true;
        dispatch({ type: 'SET_LOCK', payload: lock });
        return;
      }
    }

    for (const question of state.questionAdditionals) {
      if (
        question.section === state.page &&
        question.required && 
        question.visible && 
        question.ui !== 'buttonGroup' && question.ui !== 'switch' && 
        ((question.ui === 'checkbox' && !state.answers?.some((answer) => answer.questionId === question.id && answer.value === '1')) ||
        !state.answers?.some((answer) => answer.questionId === question.id && answer.value && answer.extraID === question.subgroupId))
      ) {
        lock = true;
        dispatch({ type: 'SET_LOCK', payload: lock });
        return;
      }
    }

    dispatch({ type: 'SET_LOCK', payload: lock });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.answers, state.page]);

  const nextPage = async() => {
    if (state.lock) {
      alert('Por favor, responda todas las preguntas obligatorias');
      return;
    }

    let count = 1;
    if(state.page === 1 
      && state.answers?.some((answer) => answer.questionId === "c0a90613-28e0-496a-8c5e-e105cedef5c7" && answer.value === '1')) {
        count = 2;
    }

    const nextPage = state.page + count;

    dispatch({ type: 'SET_PAGE', payload: nextPage });

    const formattedAnswers: Answer[] = state.answers.map((answer) => ({
      group_id: answer.groupId,
      question_id: answer.questionId,
      answer: answer.value,
      page: state.page,
      form_id: FORM_ID,
      order: answer.order,
      extra_id: answer?.extraID || '',
    }));
    const groupWithExtraId = formattedAnswers.map((answer) => answer.group_id)
                              .filter((value, index, self) => self.indexOf(value) === index);
    dispatch({ type: 'SET_LOADER', payload: true });
    await saveAnswers(state.id, state.page, groupWithExtraId, formattedAnswers);
    dispatch({ type: 'SET_LOADER', payload: false });
    loadCurrentAnswers(nextPage);
  };

  const beforePage = async() => {
    if (state.page === 1) {
      navigate('/quote/?quoteID=' + quoteID);
      return;
    }
    let count = 1;
    if(state.page === 3) {
      dispatch({ type: 'SET_LOADER', payload: true });
      const extractAnswersPageOne = await recoveryAnswers(state.id, 1);
      const equalsInsuredTitular = extractAnswersPageOne?.some((answer) => answer.question_id === 'c0a90613-28e0-496a-8c5e-e105cedef5c7' && answer.answer === '1');
      if (equalsInsuredTitular) count = 2;
      dispatch({ type: 'SET_LOADER', payload: false });
    }
    dispatch({ type: 'SET_PAGE', payload: state.page - count });
    loadCurrentAnswers(state.page - count);
  };

  return (
    <ApplicationContext.Provider
      value={{
        ...state,
        setPage: (page: number) => dispatch({ type: 'SET_PAGE', payload: page }),
        nextPage,
        beforePage,
        setQuestions: (questions: any[]) => dispatch({ type: 'SET_QUESTIONS', payload: questions }),
        setAnswers: (answers: AnswerType[]) => dispatch({ type: 'SET_ANSWERS', payload: answers }),
        setQuestionsAdditionals: (questionsAdditionals: any[]) => dispatch({ type: 'SET_QUESTION_ADDITIONALS', payload: questionsAdditionals }),
        setHasError: (haveError: boolean) => dispatch({ type: 'SET_HAS_ERROR', payload: haveError }),
        setGroupsMemory: (groupsMemory: GroupMemory[]) => dispatch({ type: 'SET_GROUPS_MEMORY', payload: groupsMemory }),
        setLoader: (loading: boolean) => dispatch({ type: 'SET_LOADER', payload: loading }),

      }}
    >
      {children}
    </ApplicationContext.Provider>
  );
};